/** @format */

const template = `
<div class="prerequisite-group-container" ng-repeat="prerequisiteGroup in $ctrl.prerequisites">
  <div class="form-group grouping-panel">
    <h4 translate="STUDIES.PREREQUISITES_EDITOR.PREREQUISITE_GROUP" translate-value-index="{{$index + 1}}"></h4>
    <menu-button options="$ctrl.getMenuOptions($index)"></menu-button>
    <div ng-repeat="prerequisite in prerequisiteGroup.prerequisites" class="prerequisites">
      <sis-course-unit-box
        ng-if="prerequisite.type === 'CourseUnit'"
        [course-unit-group-id]="prerequisite.courseUnitGroupId"></sis-course-unit-box>
      <sis-module-box ng-if="prerequisite.type === 'Module'" [module-group-id]="prerequisite.moduleGroupId"></sis-module-box>
    </div>
  </div>
  <h4 ng-if="!$last" translate>STUDIES.COURSE_UNIT_INFO_MODAL.OR</h4>
</div>
<div class="add-new">
  <button type="button" class="link-button" ng-click="$ctrl.addNewPrerequisiteGroup()">
    <sis-icon icon="ring-plus"></sis-icon>{{'STUDIES.PREREQUISITES_EDITOR.ADD_NEW_PREREQUISITE_GROUP' | translate}}
  </button>
</div>
`;
export default template;
